import { COLOR } from '../../../../styles/variables';

export const appColors = {
    fontPrimary: COLOR.br24.black,
    fontSecondary: COLOR.br24.mediumGrey,
    backgroundPrimary: COLOR.br24.white,
    backgroundSecondary: COLOR.br24.lightGrey,
    buttonFont: COLOR.br24.white,
    buttonBackground: COLOR.br24.mediumBlueGrey,
    hiddenText: COLOR.br24.lightGrey,
    starBackground: COLOR.br24.yellow,
    emptyStarBackground: COLOR.br24.lightBlueGrey
};

export const chartColors = {
    fontPrimary: COLOR.br24.white,
    fontSecondary: COLOR.br24.mediumGrey,
    backgroundPrimary: COLOR.br24.blueGrey,
    backgroundSecondary: COLOR.br24.veryDarkBlueGrey,
    linePrimary: COLOR.br24.white,
    lineSecondary: COLOR.br24.mediumGrey,
    linePrevious: COLOR.br24.green,
    lineUser: COLOR.br24.yellow,
    lineActual: COLOR.br24.lightGrey
};
